import React, { Component } from 'react';
import _ from 'lodash';
import { WithStyles, createStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { Grid, Typography } from '@material-ui/core';
import classNames from 'classnames';
import { MyPATDialog, MyPATSelect, MyPATTextField, MyPATTextArea } from '../../common';
import CloseRounded from '@material-ui/icons/Cancel';
import Button from '@material-ui/core/Button';
import courseService from "../services/courseService";
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import { showMsg } from '../actions/loaderAlert';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { styles } from '../styling/component/AddSubMilestoneModal'


interface AddSubMilestoneModalProps extends WithStyles<typeof styles> {
	addSubMilestoneOpen: Boolean,
	addSubMilestoneCloseHandler: Function,
	milestoneData: any,
	showMsg: (msg: string, vari: string) => void,
	courseID: string,
	currentMilestone: any,
	startDate: any,
}

interface AddSubMilestoneModalStates {
	createContentStep2Open: Boolean,
	chaptersData: any,
	addedChapters: any,
	milestoneName: String,
	milestoneDuration: Number,
	milestoneDurationType: Number,
	milestoneObjective: String,
	milestoneSelected: any,
	searchTxt: String,
	searchArr: any,
	setMilestone: boolean
}

class AddSubMilestoneModal extends Component<AddSubMilestoneModalProps, AddSubMilestoneModalStates> {
	constructor(props: AddSubMilestoneModalProps) {
		super(props);
		this.state = {
			createContentStep2Open: false,
			chaptersData: [],
			addedChapters: [],
			milestoneName: "",
			milestoneDuration: 0,
			milestoneDurationType: 0,
			milestoneObjective: "",
			milestoneSelected: "",
			searchTxt: "",
			searchArr: [],
			setMilestone: true,
		};

		this.addChapters = this.addChapters.bind(this)
		this.removeChapters = this.removeChapters.bind(this)
		this.resetMilestone = this.resetMilestone.bind(this)
		this.addChapterToMilestone = this.addChapterToMilestone.bind(this)
		this.getChaptersData = this.getChaptersData.bind(this);
	};


	componentDidUpdate(prevProps: any) {
		let { currentMilestone, courseID } = this.props;
		let { setMilestone } = this.state;

		const { addSubMilestoneOpen } = this.props;

		if (this.props != prevProps) {
			if (addSubMilestoneOpen && !_.isEmpty(currentMilestone)) {
				let chapterIds = "";
				let chapterCount = currentMilestone.chapterCount;
				let isSubMilestone = 1;

				_.forEach(currentMilestone.chapters, (data: any, i: number) => {
					i != chapterCount - 1
						? chapterIds += `${data.chapterId},`
						: chapterIds += `${data.chapterId}`
				});
				courseService.getCourseChapters(courseID, chapterIds, "", isSubMilestone).then((responseData: any) => {
					if (!_.isEmpty(responseData) && responseData !== "Package Not Found") {
						this.setState({
							chaptersData: responseData
						})
					}
				});

				this.setState({
					milestoneSelected: currentMilestone,
					setMilestone: false
				})

			}
		}
	}

	getChaptersData(flag: string) {
		var self = this;
		const { courseID } = this.props
		courseService.getCourseChapters(courseID, "", "").then((responseData: any) => {
			if (!_.isEmpty(responseData) && responseData !== "Package Not Found") {
				self.setState({
					chaptersData: responseData
				})
			}
		});
	}

	searchChaptersData(searchTxt: string) {
		var self = this;
		const { addedChapters } = this.state;
		const { courseID } = this.props

		if (searchTxt == "") {
			self.setState({
				searchArr: []
			})
		}

		if (searchTxt.length < 3) {
			return
		}

		var selectedArr = addedChapters.map(function (value: any) {
			return value.id
		})
		selectedArr = selectedArr.join(",") || ""

		courseService.getCourseChapters(courseID, selectedArr, searchTxt.replace(/[^A-Z0-9]+/ig, "_")).then((responseData: any) => {
			if (!_.isEmpty(responseData) && responseData !== "Package Not Found") {
				self.setState({
					searchArr: responseData
				})
			}
		});
	}

	addChapters(event: any) {
		const { courseID } = this.props
		var name = event.currentTarget.getAttribute("data-name")
		var key = event.currentTarget.getAttribute("data-id")
		var index = event.currentTarget.getAttribute("data-index")
		let milestoneArray = this.props.milestoneData[index] || []
		let chapterArr = milestoneArray["chapters"].map(function (v: any) {
			return v.chapterId
		});
		courseService.getCourseChapters(courseID, chapterArr.join(","), "", 1).then((responseData: any) => {
			if (!_.isEmpty(responseData) && responseData !== "Package Not Found") {
				this.setState({
					milestoneSelected: { _id: key, name: name },
					searchTxt: "",
					searchArr: [],
					chaptersData: responseData
				})
			} else {
				// self.props.showMsg("", 'error');
				this.setState({
					milestoneSelected: { _id: key, name: name },
					searchTxt: "",
					searchArr: [],
					chaptersData: []
				})
			}
		});
	}

	addChapterToMilestone(event: any) {
		var name = event.currentTarget.getAttribute("data-name")
		var key = event.currentTarget.getAttribute("data-id")
		var { addedChapters } = this.state

		var dataArr = addedChapters.filter(function (value: any) {
			return value.id == key
		})
		if (dataArr.length == 0) {
			addedChapters.push({
				"id": key,
				"name": name
			})
			this.setState({
				addedChapters: addedChapters,
				searchArr: []
			})

		} else {
			this.props.showMsg("Chapter already present", "error")
		}
	}

	resetMilestone() {
		this.setState({
			milestoneSelected: "",
			chaptersData: [],
			addedChapters: []
		})
	}

	removeChapters(id: any) {
		var { addedChapters } = this.state
		var dataArr = addedChapters.filter(function (value: any) {
			return value.id !== id
		})
		this.setState({
			addedChapters: dataArr
		})
	}

	handleNameChange = async (event: any) => {
		this.setState({ milestoneName: event.target.value });
	}

	handleDurationChange = async (event: any) => {
		this.setState({ milestoneDuration: event.target.value });
	}

	handleDurationType = async (event: any) => {
		this.setState({ milestoneDurationType: event.target.value });
	}

	handleObjective = async (event: any) => {
		this.setState({ milestoneObjective: event.target.value });
	}

	handleSearchChange = async (event: any) => {
		let _search = event.target.value;
		this.setState({ searchTxt: _search })
		this.searchChaptersData(_search)
	}


	handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		var self = this;
		const { courseID } = this.props

		var { milestoneName, milestoneDuration, milestoneDurationType, milestoneObjective, addedChapters, milestoneSelected } = this.state
		if (addedChapters.length == 0) {
			self.props.showMsg('Please select chapter', 'error');
			return
		}

		let chapterArr : any = [];
		for (let i = 0; i < addedChapters.length; i++) {
			chapterArr.push({
				"chapterId": addedChapters[i].id
			})
		}

		if (chapterArr.length == 0) {
			self.props.showMsg('No Chapters selected', 'error');
			return
		}
		var parameter = {
			"name": milestoneName,
			"tentativeDuration": milestoneDurationType,
			"number": milestoneDuration,
			"objective": milestoneObjective,
			"chapters": chapterArr,
			"milestoneId": milestoneSelected._id
		}
		courseService.addSubMilestone(courseID, parameter).then((responseData: any) => {

			if (responseData.statusCode === 200) {
				if (!_.isEmpty(responseData.responseObject)) {
					self.props.showMsg(responseData.responseMessage, 'success');
					self.props.addSubMilestoneCloseHandler()
					self.resetMilestone();
					// reload location for 
					window.location.reload();
				}
				// location.reload();
			} else {
				self.props.showMsg(responseData.responseMessage, 'error');
			}

		});

	}

	displayDuration = () => {
		let durationMessage:string = '';
		const formatDate = (date:any) => {
			const months = [
				'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
			];
			
			return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
		}
		
		const { milestoneDuration, milestoneDurationType }:any = this.state;
		const startDate = _.get(this.props, 'startDate', '');
		
		let endDate = '(Select duration from above)';

		if (!_.isEmpty(milestoneDuration) && !_.isEmpty(milestoneDurationType)) {
			let date = new Date(startDate);
			switch(milestoneDurationType) {
				case 'Days': {
					date.setDate(date.getDate() + _.toNumber(milestoneDuration) - 1)
				}
				break;

				case 'Weekly': {
					date.setDate(date.getDate() + (_.toNumber(milestoneDuration) * 7) - 1)
				}
				break;

				case 'Monthly': {
					date.setDate(date.getDate() + (_.toNumber(milestoneDuration) * 30) - 1)
				}
				break;

				case 'Yearly': {
					date.setDate(date.getDate() + (_.toNumber(milestoneDuration) * 365) - 1)
				}
				break;
			}

			endDate = formatDate(date);
		}


		if (!_.isEmpty(startDate)) {
			const date:any = formatDate(new Date(startDate));
			durationMessage = `${date} - ${endDate}`;
		}
		
		return durationMessage;
	}

	render() {
		const { classes, addSubMilestoneOpen, addSubMilestoneCloseHandler, milestoneData } = this.props;
		const { chaptersData, addedChapters, milestoneSelected, searchArr } = this.state;
		const _self = this;
		const otherDialogProps = {
			fullWidth: true,
			maxWidth: 'md',
			scroll: 'body',
		};

		return (
			<>
				<MyPATDialog
					dialogHeading={<Typography className={classes.headerLeft}>Create Sub Milestone</Typography>}
					dialogOpen={addSubMilestoneOpen}
					otherDialogProps={otherDialogProps}
					dialogHasActions={false}
					onDialogClose={addSubMilestoneCloseHandler}
				>
					<form onSubmit={this.handleSubmit.bind(this)} >
						<Grid container>
							<Grid container>
								<Grid item xs={2}>
									<img style={{ width: "120px", height: "108px" }} src="/assets/img/course/submilestone.png" alt="submilestone" />
								</Grid>
								<Grid item xs={4}>
									<Grid container alignItems="center" spacing={8}>
										<Grid item xs={12}>
											<Typography variant="h6">Name</Typography>
										</Grid>
										<Grid item xs={12}>
											<MyPATTextField
												inputId="milestoneName"
												name="milestoneName"
												onChange={this.handleNameChange}
												fullWidthControl
												placeholder="Name"
												inputProps={{
													required: true,
													minLength: 3
												}}
											/>
										</Grid>
									</Grid>
								</Grid>

								<Grid item xs={6} className={classes.tentativeDuration}>
									<Grid container alignItems="center" spacing={8}>
										<Grid item xs={12}>
											<Typography variant="h6">Tentative Duration</Typography>
										</Grid>

										<Grid item xs={8}>
											<MyPATSelect
												multiple
												fullWidthControl
												required
												onChange={this.handleDurationChange}
												label=""
												inputId="milestoneDurationNo"
												name="milestoneDurationNo"
											>
												<option value="">Select No</option>
												{
													[...Array(30)].map(function (v, i) {
														return <option value={i + 1}>{i + 1}</option>
													})
												}
											</MyPATSelect>
										</Grid>

										<Grid item xs={4}>
											<MyPATSelect
												multiple
												fullWidthControl
												onChange={this.handleDurationType}
												label=""
												inputId="milestoneDays"
												name="milestoneDays"
											>
												<option value="">Select</option>
												<option value="Days">Days</option>
												<option value="Weekly">Weeks</option>
												<option value="Monthly">Months</option>
												<option value="Yearly">Years</option>
											</MyPATSelect>
										</Grid>

										<Grid item xs={12}>
											<Typography>
												{this.displayDuration()}
											</Typography>
										</Grid>
									</Grid>
								</Grid>
							</Grid>

							<Typography variant="h6" style={{ marginTop: "45px" }}>
								{
									milestoneSelected == ""
										?
										"Select Parent Milestone"
										:
										<>
											<ChevronLeftIcon onClick={this.resetMilestone}>chevron_left</ChevronLeftIcon>{milestoneSelected.name}
											<Typography variant="body1">
												Select chapter or content for this sub milestone
												</Typography>
										</>
								}
							</Typography>

							<Grid container className={classes.cardContainer}>
								{/* {
									addedChapters.map((value: any, index: any) => {
										return <div key={value.id} className={classes.breadCrumbs}>
											{value.id} <CloseRounded onClick={() => { _self.removeChapters(value.id) }} />
										</div>
									})
							} */}
								<Grid item xs={12} style={{ margin: "10px" }}>
									{
										milestoneSelected == ""
											?
											milestoneData.map((value: any, index: any) => (
												<div key={`${value._id}  ${index}`} data-index={index} data-name={value.name} data-id={value._id} onClick={_self.addChapters} className={classes.chaptersDiv}>
													{value.name}
												</div>
											))
											:

											<Grid container>
												{
													addedChapters.map((value: any, index: any) => {
														return <div key={`${value._id}  ${index}`} className={classes.breadCrumbs}>
															{value.name} <CloseRounded onClick={() => { _self.removeChapters(value.id) }} />
														</div>
													})
												}


												<Grid item xs={12} className={classNames(classes.searchWrapper)}>
													{/* <MyPATTextField
												inputId="chapterToCover"
												name="chapterToCover"
												fullWidthControl
												placeholder="Search"
												onChange={this.handleSearchChange.bind(this)}
												inputProps={{
													autoComplete: "off"
												}}
											/> */}
													{/* <div className={classes.searchList}>
												{
													searchArr.map((value: any, index: any) => {
														return <Paper className={classes.paper} square>
															<MenuItem
																key={value._id}
																data-id={value._id}
																data-name={value.name}
																selected={false}
																component="div"
																onClick={_self.addChapterToMilestone}
																style={{
																	fontWeight: 500,
																}}
															>
																{value.name}
															</MenuItem>
														</Paper>
													})
												}
											</div> */}
												</Grid>
												<Grid item xs={12}>
													{chaptersData.map((value: any, index: any) => (
														<div key={`${value._id}  ${index}`} data-name={value.name} data-id={value._id} onClick={_self.addChapterToMilestone} className={classes.chaptersDiv}>
															{value.name}
														</div>
													))}
												</Grid>
											</Grid>
									}


								</Grid>
							</Grid>

							<Grid item xs={12} className={classes.marginTop20} >
								<Typography variant="h6">Objective</Typography>
								<MyPATTextArea
									inputId="milestoneObjective"
									name="milestoneObjective"
									placeholder="Describe the goal you want to achieve by the end of this milestone."
									onChange={this.handleObjective.bind(this)}
									rows="5"
									multiline
									fullWidthControl
								/>
							</Grid>

						</Grid>

						<Grid item xs={12}>
							<Button
								variant="contained"
								type="submit"
								color="primary"
								className={classes.btnAlign}
							>
								Create Milestone
						</Button>
						</Grid>
						<br />
						<br />
					</form>
				</MyPATDialog>
			</>
		)
	}
};

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
	{
		showMsg: showMsg
		// ServerAlertAction
	},
	dispatch
);


// @ts-ignore
export default connect(null, mapDispatchToProps)(withStyles(styles)(AddSubMilestoneModal));